import React, { Component } from 'react';
export default class Volume extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        let showeble = (this.props.volume * (!!this.props.multiplayFector && this.props.multiplayFector !== 0 ? this.props.multiplayFector : 1)).toFixed(1)
        if(!!this.props.bettingType && this.props.bettingType === 'BOOKMAKER'){
            if(showeble > 99999) {
                showeble = ((showeble/100000).toFixed(1)).toString();
                if(showeble.split('.')[1] === '0'){
                    showeble = showeble.split('.')[0];
                }
                showeble = showeble + "L";
            } else if(showeble > 999) {
                showeble = ((showeble/1000).toFixed(1)).toString();
                if(showeble.split('.')[1] === '0'){
                    showeble = showeble.split('.')[0];
                }
                showeble = showeble + "K";
            }  else {
                if(showeble.split('.')[1] === '0'){
                    showeble = showeble.split('.')[0];
                }
            }  
        } else {
            if(showeble > 999) {
                showeble = ((showeble/1000).toFixed(1)).toString()+"K"
            }
        }
        return (
            <>{parseFloat(showeble) !== 0 ?showeble:""}</>
        )
    }
}
